export default "__VITE_ASSET__BZCjFN9V__"